import axios from "axios";
import config from "../../config.json";

export const getCallsByRestaurant = async () => {
  try {
    const res = await axios.get(
      `${config.dev}/v2/calls/restaurant-calls`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching calls:", error);
    throw error;
  }
};

export const acknowledgeCall = async (callId) => {
  try {
    const res = await axios.put(
      `${config.dev}/v2/calls/acknowledge/${callId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error acknowledging call:", error);
    throw error;
  }
};

export const completeCall = async (callId) => {
  try {
    const res = await axios.put(
      `${config.dev}/v2/calls/complete/${callId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error completing call:", error);
    throw error;
  }
};

export const deleteAllCalls = async () => {
  try {
    const res = await axios.delete(
      `${config.dev}/v2/calls/delete-all`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error deleting all calls:", error);
    throw error;
  }
};

